{
    "CX_Record_Licences_None": "Keiner",
    "CX_Record_Licences_CXRRecord": "Röntgenaufnahme des Brustkorbs",
    "CX_Record_Licences_CXRUser": "CXR-Nutzer",
    "CX_Record_Licences_CXRManager": "CXR-Manager",
    "CX_Record_Device_Or_Agent_Error": "Für ein {} Abonnement ist ein Agent oder ein Gerät erforderlich.",
    "NAME": "CXRecordLanguage"
}